<template>
  <v-card>
    <v-layout row wrap align-center justify-center fill-height>
      <v-flex xs12 md10>
        <v-card-text>
          <strong>Сведения о научной эффективности структурного подразделения, ходатайствующего о создании
            диссертационного совета РХТУ им. Д.И. Менделеева</strong>
        </v-card-text>
        <v-card-text class="text-xs-left">Структурное подразделение* представляет информацию по каждой научной
          специальности (отрасли науки) создаваемого постоянно действующего диссертационного совета за 5 лет,
          предшествующих году подачи ходатайства о создании диссертационного совета РХТУ им. Д.И. Менделеева.
        </v-card-text>
        <v-card-text class="text-xs-left">* в случае, если ходатайство подается несколькими структурными подразделениями
          указывается общее количество человек/единиц.
        </v-card-text>
        <v-card-text class="text-xs-left">** доктора наук по специальности, которую они представляют в совете - доктора
          наук, а также лица, имеющие ученую степень, полученную в иностранном государстве, признаваемую в Российской
          Федерации, обладателю которой предоставлены те же академические и (или) профессиональные права, что и доктору
          наук, в соответствии со статьей 6.2. Федерального закона от 23 августа 1996 г. № 127-ФЗ «О науке и
          государственной научно-технической политике», соответствующие требованиям к членам диссертационного совета по
          научной эффективности (имеющие необходимое количество публикаций по соответствующей научной специальности,
          научных мероприятий).
        </v-card-text>

        <v-data-table
          hide-headers
          :items="science"
          class="elevation-1"
          hide-actions
        >

          <template v-slot:items="props">

            <td class="text-xs-left">
              <v-card-text v-html="rowName[props.item.obj.name]"></v-card-text>
            </td>

            <td class="text-xs-left" v-if="props.item.obj.value0 !== undefined">
              <v-text-field v-if="props.item.obj.name =='speciality'" readonly
                            v-model="props.item.obj.value0.speciality"></v-text-field>
              <v-text-field v-else-if="props.item.obj.name =='vak_start'
              || props.item.obj.name =='vak_end'" type="date"
                            v-model="props.item.obj.value0"
                            :disabled=disabled0
              ></v-text-field>
              <v-checkbox v-else-if="props.item.obj.name =='vak'" v-model="props.item.obj.value0"
                          @change="check($event,props.item.obj,'value0')"></v-checkbox>

              <v-text-field v-else-if="props.item.obj.name =='vak_protected_candidates'
              || props.item.obj.name =='vak_protected_doctors' ||
               props.item.obj.name =='vak_discontinued_by_applicator' ||
                props.item.obj.name =='vak_cancels' ||
                props.item.obj.name =='vak_returns' ||
                props.item.obj.name =='vak_remarks'"
                            v-model="props.item.obj.value0"
                            :disabled=disabled0
                            type="number"
                            :rules="[rules.required, rules.number, ]"
              ></v-text-field>

              <v-text-field v-else v-model="props.item.obj.value0"
                            type="number"
                            :rules="[rules.required, rules.number, ]"
              ></v-text-field>

            </td>

            <td class="text-xs-left" v-if="props.item.obj.value1 !== undefined">
              <v-text-field v-if="props.item.obj.name =='speciality'" readonly
                            v-model="props.item.obj.value1.speciality"></v-text-field>
              <v-text-field v-else-if="props.item.obj.name =='vak_start'
              || props.item.obj.name =='vak_end'" type="date"
                            v-model="props.item.obj.value1"
                            :disabled=disabled1
              ></v-text-field>
              <v-checkbox v-else-if="props.item.obj.name =='vak'" v-model="props.item.obj.value1"
                          @change="check($event,props.item.obj,'value1')"></v-checkbox>

              <v-text-field v-else-if="props.item.obj.name =='vak_protected_candidates'
              || props.item.obj.name =='vak_protected_doctors' ||
               props.item.obj.name =='vak_discontinued_by_applicator' ||
                props.item.obj.name =='vak_cancels' ||
                props.item.obj.name =='vak_returns' ||
                props.item.obj.name =='vak_remarks'"
                            v-model="props.item.obj.value1"
                            :rules="[rules.required, rules.number, ]"
                            type="number"
                            :disabled=disabled1></v-text-field>


              <v-text-field v-else v-model="props.item.obj.value1"
                            type="number"
                            :rules="[rules.required, rules.number, ]"
              ></v-text-field>

            </td>

            <td class="text-xs-left" v-if="props.item.obj.value2 !== undefined">
              <v-text-field v-if="props.item.obj.name =='speciality'" readonly
                            v-model="props.item.obj.value2.speciality"></v-text-field>
              <v-text-field v-else-if="props.item.obj.name =='vak_start'
              || props.item.obj.name =='vak_end'" type="date"
                            v-model="props.item.obj.value2"
                            :disabled=disabled2
              ></v-text-field>
              <v-checkbox v-else-if="props.item.obj.name =='vak'" v-model="props.item.obj.value2"
                          @change="check($event,props.item.obj,'value2')"></v-checkbox>

              <v-text-field v-else-if="props.item.obj.name =='vak_protected_candidates'
              || props.item.obj.name =='vak_protected_doctors' ||
               props.item.obj.name =='vak_discontinued_by_applicator' ||
                props.item.obj.name =='vak_cancels' ||
                props.item.obj.name =='vak_returns' ||
                props.item.obj.name =='vak_remarks'"
                            v-model="props.item.obj.value2"
                            :rules="[rules.required, rules.number, ]"
                            type="number"
                            :disabled=disabled2></v-text-field>


              <v-text-field v-else v-model="props.item.obj.value2"
                            type="number"
                            :rules="[rules.required, rules.number, ]"
              ></v-text-field>

            </td>

          </template>
          <template v-slot:no-data>
            <v-btn color="primary" @click="initialize">Загрузить таблицу</v-btn>
          </template>
        </v-data-table>
        <v-alert
          :value="alert"
          color="green"
          dark
          border="top"
          icon="mdi-home"
          transition="scale-transition"
        >
          Таблица успешно изменена
        </v-alert>
        <v-btn block @click="save" color="primary" v-if="science.length > 0">Сохранить</v-btn>
        <v-btn class="primary" @click="printPDF"  block>
          <span v-if="!show_loadind">
            Сформировать PDF
          </span>
          <span v-else style="padding-left: 65px; width: 149px; align-content: center; text-align: center;">
            <semipolar-spinner
              :animation-duration="2000"
              :size="20"
              color="#1935ff"
            />
          </span>
        </v-btn>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
    import UserDataFormMixin from '../../../../mixins/UserDataFormMixin'
    import urls from "../../urls.js"
    import {makeGetRequest, makeUpdateRequest} from "../../../../helper";
    import {SemipolarSpinner} from 'epic-spinners'

    export default {
        name: "ScientificEffect",
        mixins: [UserDataFormMixin],
        components: {SemipolarSpinner},
        props: {
            petition: Number,
            local_admin: Boolean,
            activetab: String
        },
        data() {
            return {
                URL_CREATE: '',
                URL_UPDATE: '',
                headers: [],
                science: [],
                alert: false,
                disabled0: true,
                disabled1: true,
                disabled2: true,
                generatePdf: true,
                show_loadind: false,
                rules: {
                    required: value => !!value || 'Пустое поле',
                    number: value => {
                        const pattern = /^\d{1,13}$/
                        return pattern.test(value) || 'Не верное значение'
                    },
                },
                rowName: {
                    speciality: "<div class = 'subheading' > Научная специальность\n" +
                        "(отрасль науки)\n </div>",
                    doctors: "<div  class = 'subheading'><strong>Сведения о научных и научно-педагогических кадрах</strong></div> <div class = 'subheading' > Доктора наук**, чел.</div>",

                    candidates: "<div class = 'subheading' > Кандидаты наук, чел.</div>",

                    trained_candidates: "<div  class = 'subheading'><strong>Подготовка  научно-педагогических кадров высшей квалификации</strong></div>" +
                        "<div class = 'subheading' > Кандидаты наук, чел.\n" +
                        "(количество подготовленных и защищенных аспирантами соискателями и сотрудниками диссертаций на соискание ученой степени кандидата наук)\n </div>",

                    trained_doctors: "<div class = 'subheading' > Доктора наук, чел.\n" +
                        "(количество подготовленных и защищенных диссертаций на соискание ученой степени доктора наук)\n </div>",
                    postgraduates: "<div class = 'subheading' > Количество аспирантов, чел.</div>",
                    doctorals: "<div class = 'subheading'> Количество докторантов, чел.</div>",
                    applicants: "<div class = 'subheading'> Количество соискателей\n" +
                        "(количество лиц, прикрепленных для подготовки диссертации" +
                        " на соискание ученой степени кандидата наук без освоения" +
                        " образовательной программы подготовки научно-педагогических кадров в аспирантуре)\n </div>",

                    web_of_science_all: "<div  class = 'subheading'><strong>Публикации</strong></div><div class = 'subheading'> Количество публикаций \n" +
                        "в изданиях, индексируемых \n" +
                        "в международной базе данных Web of Science, ед. (без дублирования)\n </div>",

                    scopus_all: "<div class = 'subheading'> Количество публикаций \n" +
                        "в изданиях, индексируемых \n" +
                        "в международной базе данных Scopus, ед. (без дублирования)\n </div>",

                    wos_sc_q1_q2: "<div class = 'subheading'> из них, количество публикаций \n" +
                        "в изданиях, индексируемых \n" +
                        "в международных базах данных Web of Science и  Scopus\n" +
                        "в журналах  Q1 и Q2 \n </div>",

                    international_specialized: "<div class = 'subheading'> Количество публикаций \n" +
                        "в изданиях, индексируемых \n" +
                        "в международных специализированных профессиональных базах данных PubMed, MathSciNet, zbMATH, Chemical Abstracts, Springer или GeoRef, ед.\n </div>",

                    vak_all: "<div class = 'subheading'> Количество публикаций \n" +
                        "в изданиях, включенных \n" +
                        "в перечень, сформированный федеральным органом исполнительной власти, осуществляющим функции \n" +
                        "по выработке государственной политики и нормативно-правовому регулированию в сфере научной и научно-технической деятельности, ед. («перечень ВАК»)\n </div>",

                    monographs: "<div class = 'subheading'> Количество опубликованных рецензируемых монографий, ед.\n" +
                        "(объем не менее 5 п.л., тираж не менее 500 экз)\n </div>",

                    textbooks: "<div class = 'subheading'> Количество опубликованных учебников и учебных пособий, ед.\n" +
                        "(объем не менее 5 п.л., тираж не менее 500 экз)\n </div>",

                    patent: "<div class = 'subheading'> Число патентов на изобретения, (патентов (свидетельств) " +
                        "на полезную модель, промышленный образец, селекционные достижения; свидетельства на программу" +
                        " для электронных вычислительных машин, базу данных, топологию интегральных микросхем, " +
                        "зарегистрированные в установленном законодательством порядке) </div>",

                    international_reports: "<div  class = 'subheading'><strong>Научные мероприятия (конференции, съезды, симпозиумы, конгрессы)</strong></div>" +
                        "<div class = 'subheading'> Публичные доклады на международных научных мероприятиях </div>",

                    all_russian_reports: "<div class = 'subheading'> Публичные доклады на всероссийских научных мероприятиях </div>",

                    invited_reports: "<div class = 'subheading'> Приглашенные доклады на всероссийских и международных научных мероприятиях </div>",

                    vak: "<div  class = 'subheading'><strong>В структурном подразделении действовал диссертационный совет," +
                        " созданный приказом Минобрнауки («диссертационные совет ВАК») по соответствующей научной " +
                        "специальности и отрасли науки</strong></div>",

                    vak_start: "<div class = 'subheading'>1.\t Начало работы диссертационного совета </div>",

                    vak_end: "<div class = 'subheading'> Окончание работы диссертационного совета </div>",

                    vak_protected_candidates: "<div class = 'subheading'> 2.\tКоличество защищенных кандидатов наук (в том числе подготовивших диссертацию в другой организации, указать). </div>",

                    vak_protected_doctors: "<div class = 'subheading'> 3.\tКоличество защищенных докторов наук (в том числе подготовивших диссертацию в другой организации, указать). </div>",

                    vak_discontinued_by_applicator: "<div class = 'subheading'>4.\tКоличество диссертаций снятых с рассмотрения по заявлению соискателя \n" +
                        "(в том числе на этапе рассмотрения диссертации в  Высшей аттестационной комиссии, указать).\n</div>",

                    vak_cancels: "<div class = 'subheading'>5.\tКоличество отмен решения диссертационного совета.</div>",

                    vak_returns: "<div class = 'subheading'>6.\tКоличество возвратов аттестационных дел на доработку.</div>",

                    vak_remarks: "<div class = 'subheading'>7.\tКоличество замечаний Высшей аттестационной комиссии</div>",
                },
                loadscience: [],
            }
        },
        watch: {
            $props: {
                handler() {
                    if(this.activetab ==="tab-3")
                        if(this.petition !== undefined)
                            this.initialize()

                },
                deep: true,
                immediate: true,
            },
        },
        computed: {},

        methods: {
            printPDF() {
                this.generatePdf = true;
                this.show_loadind = true;
                let status = true;
                const type = "application/pdf";
                const name = 'file.pdf';
                makeGetRequest(
                    urls.getUrl('admin|petition|petition|petition_create_permanent_council|department-make-file', 'make_file').replace('<petition>', this.petition),
                ).then(resp => {
                    if (!resp.ok) {
                        status = false;
                    }
                    return resp.blob();
                }).then(blob => {
                    this.download(blob, name, type);
                    this.generatePdf = false;
                    this.show_loadind = false;
                })

            },
            download(content, fileName, contentType) {
                var a = document.createElement("a");
                a.href = URL.createObjectURL(content);
                a.download = fileName;
                a.click();
            },
            check: function (e, a, c) {

                if (c === 'value0')
                    this.disabled0 = !e
                if (c === 'value1')
                    this.disabled1 = !e
                if (c === 'value2')
                    this.disabled2 = !e
            },

            save() {

                for (let key in this.science) {
                    let str = (this.science[key].obj)

                    if (str.value0 !== undefined) {
                        let l = this.loadscience[0]
                        l[str.name] = str.value0
                    }

                    if (str.value1 !== undefined) {
                        let l = this.loadscience[1]
                        l[str.name] = str.value1
                    }

                    if (str.value2 !== undefined) {
                        let l = this.loadscience[2]
                        l[str.name] = str.value2
                    }
                }
                // console.log(this.loadscience)

                let url = urls.getUrl('admin|petition|petition|petition_create_permanent_council|department-mass_update', 'mass_update').replace('<petition>', this.petition)
                let data = Object.assign({}, this.loadscience)
                let sendData = []
                for (let key in data)
                    sendData.push(data[key])

                let status = true;
                makeUpdateRequest(url, sendData).then(resp => {
                    if (!resp.ok) {
                        status = false;
                    }
                    return resp.json()
                })
                    .then(json => {
                        if(status)
                          this.alert = true
                        this.receiveErrors(json);

                    })
            },
            initialize() {

                let url = urls.getUrl('admin|petition|petition|petition_create_permanent_council|department-list', 'list').replace('<petition>', this.petition)
                makeGetRequest(url)
                    .then(resp => {
                        return resp.json()
                    }).then(json => {


                    let list = Object.assign({}, json);
                    this.loadscience = list;

                    //конвертируем данные в табличный вид
                    let obj = {}
                    var key = 0
                    var mass = []

                    for (var nkey in this.loadscience[key]) {
                        for (key in this.loadscience) {
                            let str = this.loadscience[key]
                            let datakey = "value" + key
                            if (nkey !== "id") {
                                obj.name = nkey
                                obj[datakey] = str[nkey]
                            }
                        }
                        mass.push({obj})
                        obj = {}
                        this.science = mass
                    }
                    //оригинал с ид

                    console.log(json)
                });


            }
        },
        created() {
            this.initialize()
        }
    }
</script>

<style scoped>

</style>
